import { render } from "./Letters.vue?vue&type=template&id=878904e4"
import script from "./Letters.vue?vue&type=script&lang=js"
export * from "./Letters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__